const URI_PREFIX = '/assets';

export class MarkerBiStatus {
  constructor(
    public blue: string,
    public grey: string,
  ) {
    this.blue = `${URI_PREFIX}/${blue}`;
    this.grey = `${URI_PREFIX}/${grey}`;
  }
}

export class MarkerTriStatus {
  constructor(
    public blue: string,
    public grey: string,
    public red: string,
  ) {
    this.blue = `${URI_PREFIX}/${blue}`;
    this.grey = `${URI_PREFIX}/${grey}`;
    this.red = `${URI_PREFIX}/${red}`;
  }
}

export class MarkerMap {
  constructor(
    public chep: string,
    public customer: string,
  ) {
    this.chep = `${URI_PREFIX}/${chep}`;
    this.customer = `${URI_PREFIX}/${customer}`;
  }
}

export class Markers {
  public static readonly CLASSIC = `${URI_PREFIX}/marker-cluster-blue.svg`;
  public static readonly CLASSIC_SERVICE_CENTER = `${URI_PREFIX}/marker-departure-chep-center.svg`;
  public static readonly DEPARTURE = new MarkerBiStatus('marker-departure-selected.svg', 'marker-departure-normal.svg');
  public static readonly ARRIVAL   = new MarkerBiStatus('marker-arrival-selected.svg', 'marker-arrival-normal.svg');
  public static readonly DEPARTURE_LOAD = new MarkerMap('marker-departure-chep-center.svg', 'marker-departure-customer.svg');
  public static readonly ARRIVAL_LOAD   = new MarkerMap('marker-arrival-chep-center.svg', 'marker-arrival-customer.svg');
  public static readonly TRAILER   = new MarkerBiStatus('marker-trailer-normal.svg', 'marker-trailer-selected.svg');
  public static readonly PIN       = `${URI_PREFIX}/marker-force-check-in.svg`;

  public static readonly SERVICE_CENTER = new MarkerBiStatus('marker-service-center-selected.png', 'marker-service-center-normal.png');

  public static readonly CHECKIN  = `${URI_PREFIX}/marker-check-in.svg`;
  public static readonly CHECKOUT = `${URI_PREFIX}/marker-check-out.svg`;

  public static readonly PICK_UP             = new MarkerTriStatus('marker-pick.svg', 'marker-pick-grey.png', 'marker-pick-red.png');
  public static readonly RELEASE             = new MarkerTriStatus('marker-release.svg', 'marker-release-grey.png', 'marker-release-red.png');
  public static readonly RELEASE_AND_PICK_UP = new MarkerTriStatus('marker-release-pickup.svg', 'marker-release-pickup-grey.png', 'marker-release-pickup-red.png');
}
